import React, { FC } from 'react';
import styled, { keyframes } from 'styled-components';
import { fadeIn } from 'styles/animations';
import { ReactComponent as Chart1 } from './img/gr1.svg';
import { ReactComponent as Chart2 } from './img/gr2.svg';
import { ReactComponent as Chart3 } from './img/gr3.svg';
import { CHART_TYPE } from '../../types';
import { CIRCLE2_DELAY } from '../../constants';

interface Props {
	type: CHART_TYPE;
}

export const dash = keyframes`
	to { stroke-dashoffset: 665; }
`;

const Container = styled.div<{ circle2delay: number }>`
	padding: 0 10px;
	& svg {
		box-shadow: 0px 4px 10px rgba(90, 0, 122, 0.3), inset 0px 0px 50px rgba(255, 255, 255, 0.4);
		border-radius: 8px;
		width: 100%;
		height: auto;
		z-index: 1;
	}

	& .pathAnimate {
		stroke-dasharray: 370;
		stroke-dashoffset: 292;
		will-change: ${dash};
		animation: ${dash} 3s 0.3s ease-out forwards;
	}

	& .circle1 {
		opacity: 0;
		animation: ${fadeIn} 0.7s 0.5s forwards;
	}
	& .circle2 {
		opacity: 0;
		animation: ${fadeIn} 0.7s ${({ circle2delay }) => circle2delay}s forwards;
	}
`;

export const Card: FC<Props> = props => {
	const { type = CHART_TYPE.V1 } = props;

	const CHART: Record<CHART_TYPE, React.ReactElement> = {
		[CHART_TYPE.V1]: <Chart1 />,
		[CHART_TYPE.V2]: <Chart2 />,
		[CHART_TYPE.V3]: <Chart3 />,
	};

	return <Container circle2delay={CIRCLE2_DELAY[type]}>{CHART[type]}</Container>;
};
